












import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import CourseContents from './components/landing/CourseContents.vue';
import CourseListing from './components/landing/CourseListing.vue';
import GetStarted from './components/landing/GetStarted.vue';
import LandingHero from './components/landing/LandingHero.vue';
import Motivation from './components/landing/Motivation.vue';
import TeachersFaq from './components/landing/TeachersFaq.vue';
import { educatorsPageFlowId } from 'frontend/components/util/Savvy/SavvyConstants';
import SavvyFlow from 'frontend/components/util/Savvy/SavvyFlow.vue';
import { FeatureSwitches } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('globals', ['featureSwitches']),
  },
  components: {
    CourseContents,
    CourseListing,
    GetStarted,
    LandingHero,
    Motivation,
    TeachersFaq,
    SavvyFlow,
  },
  metaInfo: {
    titleTemplate:
      'Brilliant for Educators | ' +
      'Educators receive a free Premium license from Brilliant, for free',
    meta: [
      {
        name: 'description',
        content:
          'Learn interactively in and out of the classroom. ' +
          'Your students will receive a school license from Brilliant, for free.',
      },
    ],
  },
})
export default class TeacherLanding extends Vue {
  private readonly featureSwitches!: FeatureSwitches;

  private get flowId(): string {
    return educatorsPageFlowId;
  }

  private get savvyEnabled(): boolean {
    return this.featureSwitches.enable_savvy_educators_landingpage === true;
  }
}
